import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {DialogLoadingSpinnerComponent} from './dialog-loading-spinner.component';

const COMPONENTS = [
    DialogLoadingSpinnerComponent
];

@NgModule({
    declarations: COMPONENTS,
    exports: COMPONENTS,
    imports: [
        CommonModule,
        MatProgressSpinnerModule
    ]
})
export class CbDialogLoadingSpinnerModule {
}
